import React from 'react'
import clsx from 'clsx'

import { Box, Typography, Toolbar, IconButton, Badge, AppBar, Icon } from '@mui/material'

import { CDNSVG } from '@front/volcanion'
import Menu from './Menu/'

import './styles.scss'

const TopBar = ({ navigateNotifications, navigateJobs, incident_count, job_count, children, version, isDrawerOpen, ...props }) =>
  <AppBar position="fixed" color="primary" className={clsx('appbar', { ['shift']: isDrawerOpen })} sx={{ zIndex: 1300 }}>
    <Toolbar className={clsx('toolbar', { ['shift']: isDrawerOpen })} >
      <Box display='flex' justifyContent='space-between' alignItems='center' flex={1}>
        <Box display='flex' alignItems='center'>
          {children}
        </Box>
        <Box display='flex' justifyContent='flex-end' alignItems='center'>
          <IconButton onClick={navigateJobs} aria-label={`show ${job_count} new notifications`}>
            <Badge badgeContent={job_count} color='error' sx={{ m: 0 }}>
              <CDNSVG style={{ fill: 'white' }} name={'dispatch-in_coming'} />
            </Badge>
          </IconButton>
          <IconButton onClick={navigateNotifications} aria-label={`show ${incident_count} new notifications`}>
            <Badge badgeContent={incident_count} color='error' sx={{ m: 0 }}>
              <Icon sx={{ color: 'white' }}>notifications</Icon>
            </Badge>
          </IconButton>
          <Menu {...props} />
          <Typography variant={'h4'} sx={{ ml: 1, color: 'white' }}> | </Typography>
          <Typography variant={'h5'} sx={{ ml: 1, mr: 2, color: 'white' }}> {version || 'local'} </Typography>
        </Box>
      </Box>
    </Toolbar>
  </AppBar >

export default React.memo(TopBar)
